export default class AllLeaderboardTracks {

    constructor() {
        this.contest_task_id = 0;
        this.order = 0;
        this.url = "";
        this.bindEvents();
    }

    bindEvents() {
        let self = this;

        $(".js-all_leaderboard_tracks_filter").unbind("click").click(function (e) {
            e.preventDefault();
            self.setFilter(this);
        });

        $(".page-link").unbind("click").click(function (e) {
            e.preventDefault();
            if($(this).attr("href")!=null) {
                self.url =  $(this).attr("href");
                self.reloadTable();
            }
        });

        // Toggle missing waypoints display
        $(".js-waypoints-toggle").unbind("click").click(function() {
            const resultId = $(this).data("result-id");
            const countElement = $(this).find(".js-waypoints-count");
            const missingElement = $(this).find(".js-missing-waypoints");
            const apiUrl = $("meta[name=api-url]").attr("content");
            const translations = window.data?.translations || {
                missing_waypoints: "Missing waypoints:",
                all_reached: "All waypoints reached!"
            };

            // Toggle visibility
            if (missingElement.hasClass("d-none")) {
                // Show missing waypoints
                if (!missingElement.data("loaded")) {
                    // Fetch missing waypoints
                    fetch(`${apiUrl}/v1/contest_task/missing_waypoints/${resultId}`, {
                        headers: {
                            'X-STL-Token': cookies.get('STL-Token')
                        }
                    })
                    .then(response => response.json())
                    .then(data => {
                        if (data.missing_waypoints && data.missing_waypoints.length > 0) {
                            const waypointsList = data.missing_waypoints
                                .map(wp => `${wp.order}. ${wp.name}`)
                                .join('<br>');
                            missingElement.html(`<strong>${translations.missing_waypoints}</strong><br>${waypointsList}`);
                        } else {
                            missingElement.html(`<em>${translations.all_reached}</em>`);
                        }
                        missingElement.data("loaded", "true");
                        countElement.addClass("d-none");
                        missingElement.removeClass("d-none");
                    })
                    .catch(error => {
                        console.error('Error fetching missing waypoints:', error);
                        missingElement.html('<em>Error loading data</em>');
                        countElement.addClass("d-none");
                        missingElement.removeClass("d-none");
                    });
                } else {
                    // Already loaded, just toggle
                    countElement.addClass("d-none");
                    missingElement.removeClass("d-none");
                }
            } else {
                // Hide missing waypoints, show count
                missingElement.addClass("d-none");
                countElement.removeClass("d-none");
            }
        });
    }


    onDataChanged(data){
        this.contest_task_id = data.contest_task_id;
        this.url =  "/contest_task/ajax_leaderboard_tracks/"+this.contest_task_id;
        this.reloadTable();
    }

    onDestroy(){
        $(".js-all_leaderboard_tracks_filter").unbind("click");
        $(".page-link").unbind("click");
        $(".js-waypoints-toggle").unbind("click");
    }


    setFilter(item) {
        let newOrder = parseInt($(item).data("order"))
        if (this.order !== newOrder){
            this.order = newOrder;
            this.url =  "/contest_task/ajax_leaderboard_tracks/"+this.contest_task_id;
            $("#js-all_leaderboard_tracks_btn").text($(item).data("name-hr"));
            this.reloadTable();
        }
    }

    reloadTable() {
        let self = this;
        $.ajax({
            url: this.url,
            type: "get",
            data: {
                order: this.order
            },
            success: function(html) {
                $("#tables-results").empty();
                $("#tables-results").append(html);
                $("#tables-results-loader").removeClass("d-flex");
                $("#tables-results-loader").addClass("d-none");
                self.bindEvents();
                window.application.reloadLazyLoad();
            },
            error: function(data) {
            }
        });
    }
}
